import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button } from '@mui/material';
import { WorkData } from '../../assets/config';
import portfolioBg from '../../assets/img/mobileLanding/portfolio-bg.png';
import portfolioWebBg from '../../assets/img/mobileLanding/portfolio-web-bg.png';
import OsperbShorts, { Reel } from './elements/ShortPlayer';
import FeaturedCaseStudies from './FeaturedCaseStudies';

function Portfolio({ type }: { type: string }) {
  // Get first 3 featured case studies
  const featuredProjects = WorkData.slice(0, 3);

  const reels: Reel[] = [
    {
      id: 1,
      thumbnail: '',
      videoUrl: 'https://youtube.com/shorts/Yx8U2j2TSLs?si=ANBw9GC4YXqVUPKM',
      title: 'Chocochi',
      views: '1.2K',
    },
    {
      id: 3,
      thumbnail: '',
      videoUrl: 'https://youtube.com/shorts/7bX-UAxIkVE',
      title: 'Osperb Short 3',
      views: '2.5K',
    },
    {
      id: 4,
      thumbnail: '',
      videoUrl: 'https://youtube.com/shorts/WvjUlkNmrMg',
      title: 'Ideal reward',
      views: '1.8K',
    },
    {
      id: 5,
      thumbnail: '',
      videoUrl: 'https://youtube.com/shorts/Vv_9HfPwr4c',
      title: '',
      views: '3.1K',
    },
    {
      id: 6,
      thumbnail: '',
      videoUrl: 'https://youtube.com/shorts/i6fvQmGn9kE',
      title: '',
      views: '3.1K',
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        padding: '60px 24px',
        pt: 10,
      }}
    >
      <FeaturedCaseStudies type={type} projects={featuredProjects} />

      <Box sx={{ backgroundColor: '#ffff', }}>
        <OsperbShorts reels={reels} height={"400px"} visibleItems={{ xs: 1.75, sm: 2.5, md: 6.5 }} />
      </Box>

      {/* Explore Full Portfolio Section */}
      {/* <Box
        sx={{
          mt: '70px',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mx: -3,
          width: 'calc(100% + 48px)',
          ...(type === 'web' ? { height: '300px', mb: 10 } : { height: '350px' }),
        }}
      >
        <Box
          component="img"
          src={type === 'web' ? portfolioWebBg : portfolioBg}
          alt="Portfolio background"
          sx={{
            width: '100%',
            height: 'auto',
          }}
        />

        <Button
          variant="outlined"
          className="font-satoshi-bold"
          endIcon={<ArrowForwardIcon />}
          sx={{
            background: '#F0FBFE',
            color: '#3C73A4',
            fontSize: '16px',
            padding: '14px 40px',
            borderRadius: '50px',
            border: '1px solid transparent',
            backgroundImage:
              'linear-gradient(white, white), linear-gradient(180deg, #39C664 0%, #45D1D6 100%)',
            backgroundOrigin: 'border-box',
            backgroundClip: 'padding-box, border-box',
            textTransform: 'none',
            transition: 'all 0.3s ease',
            position: 'absolute',
            ...(type === 'web' ? { bottom: '-50px' } : { bottom: '-20px' }),
            '&:hover': {
              background: '#F0FBFE',
              backgroundImage:
                'linear-gradient(white, white), linear-gradient(180deg, #39C664 0%, #45D1D6 100%)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: '0 4px 12px rgba(57, 198, 100, 0.3)',
            },
          }}
        >
          View All Projects
        </Button>
      </Box> */}
    </Box>
  );
}

export default Portfolio;
